/* eslint-disable no-restricted-globals */
(window as any).global = window;
